import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconImportQuestionsSvg } from './IconImportQuestionsSvg';

export type IconImportQuestionsProps = UseIconProps;

export function IconImportQuestions(props: IconImportQuestionsProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <Box tagName={IconImportQuestionsSvg} {...iconProps} />;
}
